import {
  Grid,
} from '@material-ui/core';
import {
  Button,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';


import Modal from 'components/Modal';
import AddPartner from './AddPartner';

const NoResult = ({refetch}) => {

  const {
    classes,
    global,
    cx,
  } = useStyles(styles);
  
  const [openInternalPartner, setOpenInternalPartner] = useState(false);

  return (
    <Grid item className={classes.container}>
      <h1 className={cx(classes.h1, global.title)}> Commencez à construire votre réseau de partenaires </h1>
      <div className={classes.containerInfo}>
        <div className={classes.info}>
          <div>
            <p className={cx(classes.stepStyles, classes.infoText)}> 1. Recherchez un partenariat avec un établissement de formation. </p>
            <p className={cx(classes.stepStyles, classes.infoText)}> 2. Décidez de les ajouter aux prospects avant d'envoyer vos demandes. </p>
            <p className={cx(classes.stepStyles, classes.infoText)} style={{marginBottom: '20px'}}> 3. Sourcez dans l'établissement des profils qualifiés, depuis la CVthèque. </p>
          </div>
          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={() => setOpenInternalPartner(true)}
            disableElevation
            className={classes.btn}
          >
            Rechercher un partenariat
          </Button>
        </div>
        <Modal
          onCancel={() => setOpenInternalPartner(false)}
          open={openInternalPartner}
          title="Rechercher un partenariat"
          width="1200px"
        >
          <AddPartner
            close={() => setOpenInternalPartner(false)}
            refetch={refetch}
          />
        </Modal>
      </div>
  </Grid>
  );
};

const styles = () => ({
  container: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: '30.0px',
    '@media screen and (max-width: 768px)': {
      padding: '20px',
    },
  },
  containerInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    columnGap: '20px',
    width: '100%',
    '@media screen and (max-width: 768px)': {
      alignItems: 'center',
      flexFlow: 'column',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column-reverse',
    }
  },
  stepStyles: {
    textAlign: 'center',
    margin: '10px 0 0 0',
    '@media screen and (max-width: 768px)': {
      margin: '0 0 10px 0',
    },
  },
  h1: {
    textAlign: 'center',
    margin: '0px 0px 30px 0px',
  },
});

export default NoResult;
